import { useNavigate } from 'react-router-dom';
import { Badge } from 'antd';

import { Urls } from 'shared/constants/urls';
import {
  themePrimary,
  critical,
  themeTextSecondary
} from 'shared/utils/cssUtility';
import { ChatIcon } from 'shared/components/Icons';
import classes from './styles.module.scss';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getUnreadCount,
  getUnreadCountSelector
} from 'store/patientConversation/patientConversation.redux';

const route = Urls.Messages;

const Chat = () => {
  const navigate = useNavigate();
  const unreadCount = useSelector(getUnreadCountSelector);
  const color = critical;
  const iconColor = themeTextSecondary;
  const dispatch = useDispatch();

  const isHL = (route: string) => {
    const path = window.location.pathname;
    return path === route;
  };

  const getColor = (selected: boolean) => {
    return selected ? themePrimary : iconColor;
  };

  useEffect(() => {
    const interval = setInterval(() => dispatch(getUnreadCount()), 60000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div
      // TODO: Figure out why this class is causing the icon to disaper when Note This is needed before I
      //Close out the ticket but I will come back to this
      className={classes['header__icons__chat-icon']}
      onClick={() => {
        navigate(route);
      }}
    >
      {/* TODO: Add the count of notifications here once the hook is there */}
      <Badge
        count={unreadCount}
        size={'small'}
        overflowCount={9}
        offset={[5, -1]}
        color={color}
      >
        <ChatIcon color={getColor(isHL(route))} />
      </Badge>
    </div>
  );
};

export default Chat;
